<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'layout',
})
</script>
<template>
  <div
    v-loading="loading"
    class="
       ma-custom-contain"
  >
    <sidebar
      v-if="$route.path !== '/error/401'"
      :permission-routes="permissionRoutes"
      :active-menu="asideActiveMenu"
      @collapse="changeCollapse"
      @to-blank="handleToBlankClick"
    />
    <navbar
      v-if="$route.path !== '/insight/carous/index'"
      class="ma-custom-header"
      :navbar-breadcrumbs="navbarBreadcrumbs"
      :collapse-show="collapseShow"
      :project-hide="projectHide"
      :project-disabled="projectDisabled"
      :project-multiple-select="projectMultipleSelect"
      :agi-web-chat-ref="agiWebChatRef"
      :show-agi-chat="!!agiChatConfig"
    />
    <div
      v-if="submenuPermissionRoutes.length>0"
      class="ma-custom-aside-collapse"
      :class="[
        collapseShow ? '' : 'width0'
      ]"
    >
      <sidebar-collapse
        :permission-routes="submenuPermissionRoutes"
        :active-menu="navbarActiveMenu"
        @blank-click="handleSubmenuBlankClick"
      />
    </div>

    <div
      class="ma-content-right globle-bg"
      :class="[
        collapseShow ? '' : 'contain-width',
        $route.path === '/home/index' && !isClickBlankMenu ?'contain-width' : '',
        $route.path === '/error/401' ||$route.path === '/error/404'?'all-width' : '',
        $route.path === '/insight/carous/index'?'all-width all-height' : '',
      ]"
    >
      <!-- <iframe-model
        v-if="hasThirdPartId && hasLoadedThreeModel && appStore.modelSwitch === 1"
        v-show="isThreeModel"
        :space-model-u-r-l="spaceModelURL"
        :has-third-part-id="hasThirdPartId"
      /> -->

      <!-- 第4级菜单 - tab展示 -->
      <el-tabs
        v-if="isCurrentTabsMenu"
        v-model="activeTabName"
        type="card"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          v-for="item in tabList"
          :key="item.key"
          :label="item.name"
          :name="item.key"
        />
        <the-router-view />
      </el-tabs>

      <!-- 第1-3级菜单 - 正常显示 -->
      <the-router-view v-else />

      <div
        id="subapp-viewport"
        v-show="isMicroAppPage"
      ></div>
      <agi-web-chat
        v-if="agiChatConfig"
        ref="agiWebChatRef"
        :digital-staff-id="agiChatConfig?.digitalStaffId"
        :hide-float="false"
      />
    </div>
  </div>
  <!-- <iframe
    v-if="spaceModelURL"
    :src="spaceModelURL+'1'"
    frameborder="0"
    style="display: none;width: 0; height: 0;"
  ></iframe> -->
</template>

<script setup lang="ts" name="layout">
  import {
    computed, onMounted, ref, watch,
  } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useAppStore } from '@/store/app';
  import { useOrgStore } from '@/store/org';
  import { useUserStore } from '@/store/user';
  import { usePermissionStore } from '@/store/permission';
  import { useTenantStore } from '@/store/tenant';
  import { ExpandInfo } from '@/api/modules/tenant';
  import { start } from 'qiankun';
  import config from '@/config/index';

  import { isEmpty } from '@/utils';
  import { generateBreadcrumbs } from '@/utils/menu';
  import Sidebar from './components/sidebar/index.vue';
  import Navbar from './components/navbar/index.vue';
  import TheRouterView from './components/router-view/index.vue';
  import SidebarCollapse from './components/sidebar/sidebar-collapse.vue';
  import IframeModel from './iframe-model.vue';

  interface TabItem {
    name: string
    key: string
  }

  const agiWebChatRef = ref();

  const appStore = useAppStore();
  const permissionStore = usePermissionStore();
  const orgStore = useOrgStore();
  const tenantStore = useTenantStore();
  const spaceModelURL = ref('');

  /**
   * @description: 获取当前租户的 AgiChat 配置
   * @returns digitalStaffId 和 channel，如果未配置则返回 null
   */
  const getAgiChatConfig = (): { digitalStaffId: string; channel: string } | null => {
    const currentTenant = tenantStore.currentTenant;
    if (!currentTenant?.expandInfo) {
      return null;
    }

    try {
      let expandInfo: ExpandInfo | string = currentTenant.expandInfo;
      if (typeof expandInfo === 'string') {
        expandInfo = JSON.parse(expandInfo) as ExpandInfo;
      }

      const { digitalStaffId, agiChatChannel, modelURL } = expandInfo;
      spaceModelURL.value = modelURL || 'https://c4-ontology-fe.h5-uat.longfor.com/engine/deviceEngine/?oneID=';
      // 只有当两个字段都有值时才启用 AgiChat
      if (digitalStaffId && agiChatChannel) {
        return { digitalStaffId, channel: agiChatChannel };
      }
    } catch (error) {
      console.error('解析 expandInfo 失败:', error);
    }

    return null;
  };

  // AgiChat 配置
  const agiChatConfig = computed(() => getAgiChatConfig());

  const findNodeByPath = (tree:TypeObject[], path: string):any => {
    for (const node of tree) {
      if (node.path === path) {
        return node; // 如果找到目标节点，直接返回（在树的根部）
      }
      const parent = findNodeByPath(node.children || [], path);
      if (parent) {
        return parent; // 如果在子树中找到目标节点，返回该子节点的父节点
      }
    }
    return null; // 如果没有找到，返回null
  };

  const route = useRoute();
  const router = useRouter();
  const loading = computed(() => appStore.loading);

  const permissionMenus = computed(() => permissionStore.permissionMenus);
  const routes = permissionMenus.value;
  const permissionRoutes = ref<any>(routes); // 用户所有有权限的菜单
  const submenuPermissionRoutes = ref<any>([]); // 左侧导航对应的二级菜单

  const isMicroAppPage = computed(() => config.microAppsActiveRules.some((rule:string) => route.path.startsWith(rule)));
  const collapseShow = ref(true);
  const projectDisabled = ref(false); // 导航左上角项目选择是否可用
  const projectHide = ref(false); // 导航左上角项目选择是否隐藏
  const projectMultipleSelect = ref(false); // 是否使用项目多选
  const isThreeModel = ref(false); // 是否是三维模型页面
  const hasLoadedThreeModel = ref(false); // 三维模型组件是否已加载过
  const asideActiveMenu = ref(); // 1级导航高亮菜单
  const navbarActiveMenu = ref(); // 2级导航高亮菜单
  const navbarBreadcrumbs = ref();

  const activeTabName = ref('');
  const tabList = ref<TabItem[]>([]); // 第4级tab导航菜单
  const isCurrentTabsMenu = ref(false); // 当前页面是否为第4级tab菜单

  /**
   * 从菜单数据中查找指定路径的菜单项
   */
  const findMenuInPermissionMenus = (path: string, menus: any[] = permissionRoutes.value): any => {
    for (const menu of menus) {
      if (menu.path === path) {
        return menu;
      }
      if (menu.children && menu.children.length > 0) {
        const found = findMenuInPermissionMenus(path, menu.children);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const getTabsMenuList = (curRoute: TypeObject) => {
    // 从菜单数据中获取当前路由对应的菜单项
    const currentMenu = findMenuInPermissionMenus(curRoute.path);
    if (currentMenu?.parentPath) {
      // 获取父级菜单（第3级菜单）
      const parentMenu = findMenuInPermissionMenus(currentMenu.parentPath);
      if (parentMenu?.children?.length > 0) {
        // 过滤隐藏和无权限的菜单
        tabList.value = parentMenu.children
          .filter((child: TypeObject) => !child.meta?.hidden && !child.disabled)
          .map((child: TypeObject) => ({
            name: child.title,
            key: child.path,
          }));
      }
    } else {
      // 兜底：从路由中获取
      const parentRoute = curRoute?.matched?.[curRoute.matched.length - 2];
      if (parentRoute) {
        const result = [];
        for (const item of parentRoute.children) {
          if (!item?.meta?.hidden) {
            result.push({
              name: item.meta?.title as string,
              key: item.path,
            });
          }
        }
        tabList.value = result;
      }
    }

    activeTabName.value = curRoute.path;
  };

  const changeCollapse = (value:boolean) => {
    collapseShow.value = value;
  };

  /**
   * Tab点击切换
   */
  const handleTabClick = (val: TypeObject) => {
    router.push(val.props.name);
  };

  const setAsideActiveRoute = () => {
    const findInfo = permissionRoutes.value.find((item:TypeObject) => item.path === asideActiveMenu.value);
    appStore.setAsideActiveRoute(findInfo || {});

    // 左侧导航二级菜单
    submenuPermissionRoutes.value = findInfo?.children || [];
  };

  const isClickBlankMenu = ref(false); // 标识非标准的菜单导航被点击了，比如要跳转第三方的菜单被点击了

  watch(
    () => appStore.currentMicroAppRoute,
    (newVal) => {
      isClickBlankMenu.value = false;
      if (isMicroAppPage.value) {
        // 路由切换时设置左上角项目选择用哪一种方式
        orgStore.setProjectCheckStrictly(!!newVal.meta?.projectCheckStrictly);
        isThreeModel.value = newVal?.meta?.isThreeModel as boolean;
        projectDisabled.value = newVal?.meta?.selectProjectDisabled as boolean;
        projectHide.value = newVal?.meta?.hideSelectProject as boolean;
        projectMultipleSelect.value = newVal?.meta?.projectMultipleSelect as boolean;
        // 设置顶部导航选中内容
        const activeRule = config.microAppsActiveRules.find((rule:string) => route.path.startsWith(rule));

        const activeMenuPath = newVal?.meta?.activePath
          ? String(newVal?.meta?.activePath)
          : `${activeRule || ''}${newVal.path}`;

        const activeMenu = newVal?.meta?.activeMenu
          ? String(newVal?.meta?.activeMenu)
          : `${activeRule || ''}${newVal.path}`;
        const findNode = findNodeByPath(permissionRoutes.value, activeMenu);

        if (findNode) {
          /**
           * 需要找到第1级菜单（顶级菜单）作为 asideActiveMenu
           * 对于第4级菜单，parentPath 是第3级，需要继续向上查找
           */
          let topMenu = findNode;
          while (topMenu?.parentPath) {
            const parent = findNodeByPath(permissionRoutes.value, topMenu.parentPath);
            if (parent) {
              topMenu = parent;
            } else {
              break;
            }
          }
          // 如果找到的顶级菜单不是根节点，使用其 parentPath 或自身路径
          if (topMenu && !topMenu.parentPath) {
            // topMenu 就是第1级菜单
            asideActiveMenu.value = topMenu.path;
          } else if (findNode.parentPath) {
            asideActiveMenu.value = findNode.parentPath;
          }
        }
        // 设置左侧导航菜单被选中
        navbarActiveMenu.value = activeMenuPath;

        /**
         * 检查是否为第4级菜单（从菜单数据中查找）
         * 注意：使用 activeMenuPath（带微应用前缀的完整路径）而不是 newVal.path（子应用的相对路径）
         */
        const fullPath = activeMenuPath || route.path;
        const currentMenu = findMenuInPermissionMenus(fullPath);

        const isTabsMenu = currentMenu?.meta?.isTabsMenu || newVal.meta?.isTabsMenu;
        isCurrentTabsMenu.value = !!isTabsMenu;

        // 如果是第4级菜单，需要设置tab列表
        if (isTabsMenu) {
          // 从菜单数据中获取父级菜单的子菜单作为tab列表
          const parentPath = currentMenu?.parentPath;
          if (parentPath) {
            const parentMenu = findMenuInPermissionMenus(parentPath);
            if (parentMenu?.children?.length > 0) {
              // 过滤隐藏和无权限的菜单
              tabList.value = parentMenu.children
                .filter((child: TypeObject) => !child.meta?.hidden && !child.disabled)
                .map((child: TypeObject) => ({
                  name: child.title,
                  key: child.path,
                }));
              activeTabName.value = currentMenu.path;
            }
          }
          // 设置navbarActiveMenu为父级菜单
          navbarActiveMenu.value = parentPath || activeMenuPath;
        } else {
          // 设置左侧导航菜单被选中
          navbarActiveMenu.value = activeMenuPath;
        }

        // 从菜单数据中动态生成面包屑
        const breadcrumbsFromMenu = generateBreadcrumbs(permissionMenus.value, fullPath);
        navbarBreadcrumbs.value = breadcrumbsFromMenu.length > 0 ? breadcrumbsFromMenu : newVal.meta?.breadcrumbs;

        // 获取顶部导航应该展示的导航内容
        setAsideActiveRoute();
      }
    },
    {
      immediate: true,
      deep: true,
    }
  );

  watch(
    () => route,
    (newVal) => {
      isClickBlankMenu.value = false;
      if (!isMicroAppPage.value) {
        // 路由切换时设置左上角项目选择用哪一种方式
        orgStore.setProjectCheckStrictly(!!newVal.meta?.projectCheckStrictly);

        isThreeModel.value = newVal?.meta?.isThreeModel as boolean;
        if (isThreeModel.value) {
          hasLoadedThreeModel.value = true;
        }
        projectDisabled.value = newVal?.meta?.selectProjectDisabled as boolean;
        projectHide.value = newVal?.meta?.hideSelectProject as boolean;
        projectMultipleSelect.value = newVal?.meta?.selectProjectMultiple as boolean;

        // 设置1级导航选中内容
        asideActiveMenu.value = newVal?.meta?.activeMenu || newVal.path;

        // 检查是否为第4级菜单（从菜单数据中查找）
        const currentMenu = findMenuInPermissionMenus(newVal.path);

        const isTabsMenu = currentMenu?.meta?.isTabsMenu || newVal.meta?.isTabsMenu;
        isCurrentTabsMenu.value = isTabsMenu;

        // 如果是第4级菜单，则需要高亮第3级菜单（父级）
        if (isTabsMenu) {
          // 获取父级路由（第3级菜单）
          const parentRoute = newVal.matched[newVal.matched.length - 2];
          navbarActiveMenu.value = parentRoute?.path || newVal.path;
          // 动态生成tab列表
          getTabsMenuList(newVal);
        } else {
          navbarActiveMenu.value = newVal?.meta?.navbarActiveMenu || newVal.path;
        }

        // 从菜单数据中动态生成面包屑
        const breadcrumbsFromMenu = generateBreadcrumbs(permissionMenus.value, newVal.path);
        navbarBreadcrumbs.value = breadcrumbsFromMenu.length > 0 ? breadcrumbsFromMenu : undefined;

        // 获取顶部导航应该展示的导航内容;
        setAsideActiveRoute();
      }
    },
    {
      immediate: true,
      deep: true,
    }
  );

  const hasThirdPartId = computed(() => orgStore.hasThirdPartId);

  const handleToBlankClick = (info:TypeObject) => {
    asideActiveMenu.value = info.path;
    setAsideActiveRoute();
    collapseShow.value = true;
    isClickBlankMenu.value = true;
  };

  const handleSubmenuBlankClick = (info:TypeObject) => {
    if (info.blank) {
      if (isEmpty(info.targetUrl)) {
        console.error('未配置跳转的URL');
        return;
      }
      if (info.targetUrl.startsWith('http')) {
        window.open(info.targetUrl, '_blank');
        return;
      }
      window.open(`${(import.meta.env as any)[info.targetUrl]}`, '_blank');
    }
  };

  onMounted(() => {
    if (!(window as any).qiankunStarted) {
      (window as any).qiankunStarted = true;
      start({
        prefetch: 'all', // 预加载
        sandbox: {},
      });
    }
    // 初始化摄像头图标
  });
</script>

<style scoped lang="scss">

.ma-custom-contain {
  position: relative;
  display: block;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;

  .ma-custom-header{
    position: absolute;
    top: 0;
    left: var(--maia-aside-width);
    width: calc(100vw - var(--maia-aside-width));
    height: var(--maia-nav-header-height);
    pointer-events: auto;
  }

  .ma-custom-aside-collapse{
    position: absolute;
    top: var(--maia-nav-header-height);
    left: var(--maia-aside-width);
    width: var(--maia-aside-collapse-width);
    height: calc(100vh - var(--maia-nav-header-height));
    transition: all 0.3s  linear;
  }

  .ma-content-right{
    position: absolute;
    top: var(--maia-nav-header-height);
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    width: calc(100vw - var(--maia-aside-width) - var(--maia-aside-collapse-width));
    height: calc(100vh - var(--maia-nav-header-height));
    background-color: transparent;
    transition: all 0.3s  linear;
    // box-shadow: 4px 1px 12px 8px rgba(30, 49, 72, 0.15) inset;

    &.globle-bg{
      // background-image: url('@/assets/images/bg.png');
      background-repeat: no-repeat;
      background-size: cover;
    }

    &.is-3d{
      width: 0 !important;
    }

    :deep(._avatarDialog_ryrqu_2) {
      display: none;
    }

    :deep(._chatWebPage_ryrqu_24) {
      z-index: 9999;
    }
  }

  .width0{
    width: 0;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  .contain-width{
    width: calc(100vw - var(--maia-aside-width) - 1px);
    transition: all 0.3s  linear;
  }

  .all-width{
    left: 0 !important;
    width: 100vw !important;
  }

  .all-height{
    top: 0 !important;
    height: 100vh !important;

    #subapp-viewport{
      height: 100vh !important;
    }
  }
}

// 第4级菜单tabs样式 - 只展示tab头部导航
.#{$namespace}-tabs {
  .#{$namespace}-tabs__header {
    margin-bottom: 0;
  }
}

::deep(.#{$namespace}-tabs__content) {
  padding: 0;
}

</style>
